import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'cpcs-reconnect';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
import I from 'immutable';
import FormRowField from 'pages/common/newPage/form/elements/FormRowField';
import Checkbox from 'components/form/checkbox';
import Popup from 'components/popup';
import PrivacyAndTermsLabel from 'pages/authPage/elements/PrivacyAndTermsLabel';
import { AUTH_ASK_EMAIL_POPUP, FORM_AUTH_EMAIL } from 'domain/const';
import { hidePopupAction } from 'domain/ui/UIActions';
import { authSocialNetworkEmailProvidedAction } from 'domain/env/EnvActions';
import { isPopupVisibleSelector, getPopupParamsSelector } from 'domain/ui/UIModel';
import validate from './validate';
import errorMessages from './errorMessages';
import injectSheet from 'lib/sheet';
import { sheet } from './sheet.js';

class AskEmailPopup extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    popupParams: PropTypes.instanceOf(I.Map),
    isPopupVisible: PropTypes.func.isRequired,
    finishRegistration: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  };

  onSubmit = ({ email, privacyTermsAccept, marketingEmailConsent }) => {
    const { popupParams, finishRegistration } = this.props;
    const payload = popupParams
      .setIn(['data', 'email'], email)
      .setIn(['data', 'privacyTermsAccept'], !!privacyTermsAccept)
      .setIn(['data', 'marketingEmailConsent'], !!marketingEmailConsent);
    finishRegistration(payload);
  }

  get privacyAndTermsLabel() {
    return <PrivacyAndTermsLabel />;
  }

  render() {
    const { classes, onCancel, isPopupVisible } = this.props;
    if (!isPopupVisible(AUTH_ASK_EMAIL_POPUP)) return null;
    return (
      <Popup cancel={() => onCancel()}>
        <div
          className={`${classes.container} ${classes.AskEmailPopup}`}
        >
          <div className={classes.titleWrapper}>
            <h2
              className={classes.title}
              children="Please provide an email to finish registration"
            />
          </div>
          <form
            onSubmit={this.props.handleSubmit(this.onSubmit)}
            className={classes.form}
          >
            <Field
              type="email"
              name="email"
              component={FormRowField}
              placeholder="email"
              modifier="AskEmailPopup"
              errorMessages={errorMessages}
              rootTag="div"
            />
            <Field
              name="marketingEmailConsent"
              component={FormRowField}
              modifier="AskEmailPopup"
              labelText="I consent to marketing communications from ARTBank"
              Field={Checkbox}
              id="marketingEmailConsentCheckboxInAskEmailPopup"
              errorMessages={errorMessages}
              rootTag="div"
            />
            <Field
              name="privacyTermsAccept"
              component={FormRowField}
              modifier="AskEmailPopup"
              labelText={this.privacyAndTermsLabel}
              Field={Checkbox}
              id="privacyAndTermsCheckboxInAskEmailPopup"
              errorMessages={errorMessages}
              rootTag="div"
            />
            <div className={classes.btnGroup}>
              <button
                className={cx(classes.button, 'submit', 'Popup-AskEmail-Submit')}
                type="submit"
                children="finish registration"
                data-name="submit-button"
              />
            </div>
          </form>
        </div>
      </Popup>
    );
  }
}

export default compose(
  injectSheet(sheet),
  connect({
    onCancel: hidePopupAction,
    popupParams: getPopupParamsSelector,
    isPopupVisible: isPopupVisibleSelector,
    finishRegistration: authSocialNetworkEmailProvidedAction,
  }),
  reduxForm({
    form: FORM_AUTH_EMAIL,
    validate,
  }),
)(AskEmailPopup);
